import React, { useContext, useState, useRef } from 'react'
import { Button, Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import ClsFormatacao from '../../Utils/ClsFormatacao'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import BackEndAPI from '../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'
import PesquisarTabela from '../../DevComponents/PesquisarTabela'
import InputText from '../../DevComponents/InputText'
import ClsValidacao from '../../Utils/ClsValidacao'

import { useReactToPrint } from 'react-to-print';
import Condicional from '../../Layout/Condicional'
import CabecalhoImpressao from '../../Layout/CabecalhoImpressao'
import SelectMultiplo from '../../DevComponents/SelectMultiplo'
import ClsExportDataTableCSV from '../../Utils/ClsExportDataTableCSV'
import ComboBox from '../../DevComponents/ComboBox'
import ExibirJSONDev from '../../DevComponents/ExibirJSONDev'

interface PesquisaInterface {
  dataInicial: string
  dataFinal: string
  unidades: Array<number>
  idRegional: number
  agruparPor: string
}

interface RelatorioInterface {
  registros: Array<Record<any, any>>
  cabecalho: Array<DataTableCabecalhoInterface>
}

export default function Produtividade () {

  const componentRef = useRef( null )

  const handlePrint = useReactToPrint( {
    content: () => componentRef.current,
  } )

  const handleDownload = () => {

    ( new ClsExportDataTableCSV() ).exportCSV( 'Produtividade', rsRelatorio.registros, rsRelatorio.cabecalho )

  }

  const clsFormatacao: ClsFormatacao = new ClsFormatacao()

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const CABECALHO_BASE: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'anomes',
      cabecalho: 'Período',
      alinhamento: 'left',
      format: ( v: number | string ) => {
        if ( typeof v === 'number' ) {
          let rs = v.toString();
          return rs.substring( 4, 6 ).concat( '/' ).concat( rs.substring( 0, 4 ) )
        } else {
          return v
        }
      }
    },
    {
      campo: 'vrCalc_TotalEmitido',
      cabecalho: '$ Total Emitido',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v )
    },
    {
      campo: 'vrCalc_CanceladoEstorno',
      cabecalho: '$ Canc. Estorno',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v )
    },

    {
      campo: 'CanceladoEstornoPorTotalEmitido',
      cabecalho: '% / LE',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v ).concat( '%' )
    },

    {
      campo: 'vrCalc_TotalLiquidoEmitido',
      cabecalho: '$ Líquido Emitido',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v )
    },
    {
      campo: 'vrCalc_Recebido',
      cabecalho: '$ Recebido',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v )
    },
    {
      campo: 'RecebidoPorTotalLiquidoEmitido',
      cabecalho: '% / LE',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v ).concat( '%' )
    },
    {
      campo: 'vrCalc_Receber',
      cabecalho: '$ A Receber',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v )
    },
    {
      campo: 'AReceberPorTotalLiquidoEmitido',
      cabecalho: '% / LE',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v ).concat( '%' )
    },
    {
      campo: 'vrCalc_Emdia',
      cabecalho: '$ A Receber Em Dia',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v )
    },
    {
      campo: 'AReceberEmDiaPorTotalLiquidoEmitido',
      cabecalho: '% / LE',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v ).concat( '%' )
    },
    {
      campo: 'vrCalc_Atrasado',
      cabecalho: '$ A Receber Atrasado',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v )
    },
    {
      campo: 'AReceberAtrasadoPorTotalLiquidoEmitido',
      cabecalho: '% / LE',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v ).concat( '%' )
    },
    {
      campo: 'vrCalc_Prejuizo',
      cabecalho: '$ Prejuízo',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v )
    },
    {
      campo: 'PrejuizoPorTotalLiquidoEmitido',
      cabecalho: '% / LE',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatacao.currency( v ).concat( '%' )
    },

    /*  {
      campo: 'qtdTotal',
      cabecalho: 'QTD Total',
      alinhamento: 'right'
    },
  
    {
      campo: 'qtdCanceladoEstorno',
      cabecalho: 'QTD Estorno',
      alinhamento: 'right'
    },
  
    {
      campo: 'qtdTotalLiquidoEmitido',
      cabecalho: 'QTD Líquido Emitido',
      alinhamento: 'right'
    },
  
    {
      campo: 'qtdRecebido',
      cabecalho: 'QTD Recebido',
      alinhamento: 'right'
    },
  
    {
      campo: 'qtdReceber',
      cabecalho: 'QTD A Receber',
      alinhamento: 'right'
    },
  
    */
  ]

  const [rsRelatorio, setRsRelatorio] = useState<RelatorioInterface>( {
    cabecalho: CABECALHO_BASE,
    registros: []
  } )

  const abortController: AbortController = new AbortController()

  const navigate = useNavigate()

  const btFechar = () => {
    navigate( '/' )
  }

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>( {
    dataInicial: '',
    dataFinal: '',
    unidades: [],
    idRegional: 0,
    agruparPor: 'pe'
  } )

  const validarPesquisa = (): boolean => {
    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.eData( 'dataInicial', pesquisa, erros, retorno, true )
    retorno = clsValidacao.eData( 'dataFinal', pesquisa, erros, retorno, true )

    if ( retorno
      && pesquisa.dataInicial.length > 0
      && pesquisa.dataFinal.length > 0
      && pesquisa.dataInicial > pesquisa.dataFinal
    ) {
      erros.dataInicial = 'Período Inválido!'
      erros.dataFinal = 'Período Inválido!'
      retorno = false
    }

    setErrosPesquisa( erros )

    if ( retorno ) {
      consultarRelatorio()
    }

    return retorno
  }

  const totalizarRelatorio = ( jsonString: string ): Array<Record<any, any>> => {

    const fnValorCampo = ( rs: Record<string, string | number>, campo: string ): number => typeof rs[campo] === 'string' ? parseFloat( rs[campo] as string ) : rs[campo] as number

    const fnTotalizarCampos = ( rs: Record<string, string | number>, campos: Array<string> ): number => {
      let total = 0;
      campos.forEach( ( campo ) => {
        if ( rs.hasOwnProperty( campo ) ) {
          const valor = typeof rs[campo] === 'string' ? parseFloat( rs[campo] as string ) : ( rs[campo] as number );
          if ( !isNaN( valor ) ) {
            total += valor;
          }
        }
      } );
      return total;
    }

    const calcularRelacoes = ( rsValores: Record<string, number> ): Record<string, number> => {

      let rsRetorno: Record<string, number> = { ...rsValores }

      rsRetorno.PrejuizoPorTotalLiquidoEmitido = rsRetorno.vrCalc_TotalLiquidoEmitido !== 0 ? parseFloat( ( rsRetorno.vrCalc_Prejuizo / rsRetorno.vrCalc_TotalLiquidoEmitido * 100 ).toFixed( 2 ) ) : 0
      rsRetorno.RecebidoPorTotalLiquidoEmitido = rsRetorno.vrCalc_TotalLiquidoEmitido !== 0 ? parseFloat( ( rsRetorno.vrCalc_Recebido / rsRetorno.vrCalc_TotalLiquidoEmitido * 100 ).toFixed( 2 ) ) : 0
      rsRetorno.AReceberPorTotalLiquidoEmitido = rsRetorno.vrCalc_TotalLiquidoEmitido !== 0 ? parseFloat( ( rsRetorno.vrCalc_Receber / rsRetorno.vrCalc_TotalLiquidoEmitido * 100 ).toFixed( 2 ) ) : 0
      rsRetorno.AReceberEmDiaPorTotalLiquidoEmitido = rsRetorno.vrCalc_TotalLiquidoEmitido !== 0 ? parseFloat( ( rsRetorno.vrCalc_Emdia / rsRetorno.vrCalc_TotalLiquidoEmitido * 100 ).toFixed( 2 ) ) : 0
      rsRetorno.AReceberAtrasadoPorTotalLiquidoEmitido = rsRetorno.vrCalc_TotalLiquidoEmitido !== 0 ? parseFloat( ( rsRetorno.vrCalc_Atrasado / rsRetorno.vrCalc_TotalLiquidoEmitido * 100 ).toFixed( 2 ) ) : 0
      rsRetorno.CanceladoEstornoPorTotalEmitido = rsRetorno.vrCalc_TotalEmitido !== 0 ? parseFloat( ( rsRetorno.vrCalc_CanceladoEstorno / rsRetorno.vrCalc_TotalEmitido * 100 ).toFixed( 2 ) ) : 0
      // $ Prejuizo / $ Liquidido Emitido

      /*

vrCalc_CanceladoEstorno
vrCalc_TotalEmitido
vrCalc_TotalLiquidoEmitido
vrCalc_Recebido
vrCalc_Receber
vrCalc_Prejuizo
vrCalc_Emdia
vrCalc_Atrasado

*/

      return rsRetorno
    }

    // Lista de colunas Para Totalização
    const rsColunas: string[] = [
      'vrTotal',
      'vrCadastrado',
      'vrEmitido',
      'vrCancelado',
      'vrCanceladoEstorno',
      'vrBloqueado',
      'vrConcluido',
      'vrNegociacao',
      'qtdCadastrado',
      'qtdEmitido',
      'qtdCancelado',
      'qtdCanceladoEstorno',
      'qtdBloqueado',
      'qtdConcluido',
      'qtdNegociacao',
      'vrPago',
      'vrExecutado',
      'vrAtrasado'
    ];

    let rsTotais: Record<any, any> = {}

    let rsRelatorio: Array<Record<string, string | number>> = JSON.parse( jsonString )

    rsColunas.forEach( col => rsTotais[col] = 0 )

    /*
"anomes": 'Total',
vrCalc_TotalEmitido: rsTotais['vrEmitido'],
vrCalc_CanceladoEstorno: rsTotais['vrEmitido'],
vrCalc_TotalLiquidoEmitido: rsTotais['vrEmitido'],
vrCalc_Recebido: rsTotais['vrEmitido'],
vrCalc_Receber: rsTotais['vrEmitido'],
vrCalc_Prejuizo: rsTotais['vrEmitido'],
*/

    rsRelatorio.forEach( ( rs, indice ) => {

      rsColunas.forEach( ( nome ) => {
        rsTotais[nome] += ( ( typeof rs[nome] === 'string' ) ? parseFloat( rs[nome] as string ) : rs[nome] as number )
      } )

      rsRelatorio[indice]['vrCalc_CanceladoEstorno'] = fnValorCampo( rs, 'vrCanceladoEstorno' ) - fnValorCampo( rs, 'vrExecutado' )
      rsRelatorio[indice]['vrCalc_TotalEmitido'] = fnTotalizarCampos( rs, ['vrEmitido', 'vrCanceladoEstorno', 'vrBloqueado', 'vrConcluido'] )
      rsRelatorio[indice]['vrCalc_TotalLiquidoEmitido'] = fnValorCampo( rsRelatorio[indice], 'vrCalc_TotalEmitido' ) - fnValorCampo( rsRelatorio[indice], 'vrCalc_CanceladoEstorno' ) - fnValorCampo( rs, 'vrExecutado' )
      rsRelatorio[indice]['vrCalc_Recebido'] = fnValorCampo( rs, 'vrPago' )
      rsRelatorio[indice]['vrCalc_Receber'] = fnValorCampo( rsRelatorio[indice], 'vrCalc_TotalLiquidoEmitido' ) - fnTotalizarCampos( rs, ['vrPago'] )
      rsRelatorio[indice]['vrCalc_Prejuizo'] = fnValorCampo( rs, 'vrExecutado' )
      rsRelatorio[indice]['vrCalc_Emdia'] = fnValorCampo( rsRelatorio[indice], 'vrCalc_Receber' ) - fnValorCampo( rs, 'vrAtrasado' )
      rsRelatorio[indice]['vrCalc_Atrasado'] = fnValorCampo( rs, 'vrAtrasado' )

      rsRelatorio[indice] = calcularRelacoes( rsRelatorio[indice] as Record<string, number> )

    } )

    const tmp: Record<string, number> = {}

    tmp['vrCalc_CanceladoEstorno'] = fnValorCampo( rsTotais, 'vrCanceladoEstorno' ) - fnValorCampo( rsTotais, 'vrExecutado' )
    tmp['vrCalc_TotalEmitido'] = fnTotalizarCampos( rsTotais, ['vrEmitido', 'vrCanceladoEstorno', 'vrBloqueado', 'vrConcluido'] )
    tmp['vrCalc_TotalLiquidoEmitido'] = tmp['vrCalc_TotalEmitido'] - tmp['vrCalc_CanceladoEstorno'] - fnTotalizarCampos( rsTotais, ['vrExecutado'] )
    tmp['vrCalc_Recebido'] = fnTotalizarCampos( rsTotais, ['vrPago'] )
    tmp['vrCalc_Receber'] = tmp['vrCalc_TotalLiquidoEmitido'] - fnTotalizarCampos( rsTotais, ['vrPago'] )
    tmp['vrCalc_Prejuizo'] = fnTotalizarCampos( rsTotais, ['vrExecutado'] )
    tmp['vrCalc_Emdia'] = tmp['vrCalc_Receber'] - fnValorCampo( rsTotais, 'vrAtrasado' )
    tmp['vrCalc_Atrasado'] = fnValorCampo( rsTotais, 'vrAtrasado' )

    rsRelatorio.push( {
      "anomes": 'Total', ...calcularRelacoes( tmp as Record<string, number> )
    } )

    return rsRelatorio
  }

  const [errosPesquisa, setErrosPesquisa] = useState( {} )

  const consultarRelatorio = () => {
    const query = `
      relProdutividade (
        dataInicial: "${pesquisa.dataInicial}",
        dataFinal: "${pesquisa.dataFinal}",
        unidades: ${JSON.stringify( pesquisa.unidades )},
        idRegional: ${pesquisa.idRegional},
        agruparPor: "${pesquisa.agruparPor}"
      ) {
        ok
        mensagem
      }
    `

    const clsApi = new BackEndAPI()

    clsApi.query<RespostaPadraoInterface>( query, 'relProdutividade', 'Gerando Relatório de Produtividade...', contexto, abortController ).then( rsOK => {

      if ( rsOK.ok ) {

        let cabecalho = CABECALHO_BASE

        if ( pesquisa.agruparPor === 'un' ) {
          cabecalho.splice( 1, 0,
            {
              campo: 'descricaoUnidade',
              cabecalho: 'Unidade',
              alinhamento: 'left',
            } )
        } else if ( pesquisa.agruparPor === 're' ) {
          cabecalho.splice( 1, 0,
            {
              campo: 'descricaoRegional',
              cabecalho: 'Regional',
              alinhamento: 'left',
            } )
        } else if ( pesquisa.agruparPor === 'rp' ) {
          cabecalho.splice( 1, 0,
            {
              campo: 'nomeResponsavelPreenchimento',
              cabecalho: 'Responsável Preenchimento',
              alinhamento: 'left',
            },
            {
              campo: 'cpfResponsavelPreenchimento',
              cabecalho: 'CPF',
              alinhamento: 'left',
            }
          )
        }

        setRsRelatorio( {
          cabecalho: cabecalho,
          registros: totalizarRelatorio( rsOK.mensagem )
        } )

      } else {
        setRsRelatorio( {
          cabecalho: CABECALHO_BASE,
          registros: []
        } )
      }

    } ).catch( ( e ) => {
      console.log( e.message )

      setMensagemState( {
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Gerar Relatório de Produtividade!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

    } )
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 5 }} >

        <Paper variant="outlined" sx={{ padding: 2 }} className='content' ref={componentRef} >

          <CabecalhoImpressao />

          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Relatório de Produtividade
                <Typography variant="body2" gutterBottom>
                  Comparativo entre Emitidos, Cancelados, Pagos
                </Typography>
              </Typography>

              <IconButton onClick={() => btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} sx={{ mb: 3 }}>

              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>

                <Grid item xs={6} sm={3} md={2} >

                  <InputText
                    dados={pesquisa}
                    field='dataInicial'
                    label='Início'
                    setState={setPesquisa}
                    erros={errosPesquisa}
                    tipo='date'
                    mask='00/00/0000'
                    textAlign="right"
                  />

                </Grid>

                <Grid item xs={6} sm={3} md={2} sx={{ pl: { xs: 1 } }}>

                  <InputText
                    dados={pesquisa}
                    field='dataFinal'
                    label='Término'
                    setState={setPesquisa}
                    erros={errosPesquisa}
                    tipo='date'
                    mask='00/00/0000'
                    textAlign="right"
                  />

                </Grid>

                <Grid item xs={12} sm={6} md={3} sx={{ pl: { sm: 1 } }}>
                  <ComboBox
                    campoDescricao='descricao'
                    campoID='id'
                    dados={pesquisa}
                    field='agruparPor'
                    setState={setPesquisa}
                    erros={errosPesquisa}
                    label='Agrupar'
                    opcoes={
                      [
                        { id: 'pe', descricao: 'Período' },
                        { id: 'un', descricao: 'Unidade' },
                        { id: 're', descricao: 'Regional' },
                        { id: 'rp', descricao: 'Preenchimento' },
                      ]}
                  />

                </Grid>

                <Grid item xs={12} md={5} sx={{ pl: { md: 1 } }} >

                  <PesquisarTabela<any>
                    setState={setPesquisa}
                    field='idRegional'
                    fieldSet='idRegional'
                    label='Regional'
                    dados={pesquisa}
                    campoQueryPesquisaID='idRegional'
                    campoQueryPesquisa='pesquisa'
                    camposRetornoQueryPesquisa='{idRegional, descricao}'
                    campoLabelQueryPesquisa='descricao'
                    nomeQueryPesquisa='getRegionais'
                    nomeQueryPesquisaID='getRegionalPorId'
                    mensagemPesquisa='Procurando Regional...'
                    erros={errosPesquisa}
                    pesquisarTudoAoIniciar={true}
                  />

                </Grid>

                <Grid item xs={12} >

                  <SelectMultiplo
                    dados={pesquisa}
                    field='unidades'
                    fieldIdSelect='idUnidade'
                    fieldSelect='descricao'
                    label='Unidades'
                    setState={setPesquisa}
                    // onChange={( rs ) => console.log( rs )}
                    pesquisaInicial={{
                      mensagem: 'Pesquisando Unidades',
                      tipo: 'Query',
                      pesquisa: 'getUsuarioUnidadesPermitidasPorAcesso {idUnidade, descricao}',
                      objRetorno: 'getUsuarioUnidadesPermitidasPorAcesso'
                    }
                    }
                  />

                </Grid>

                <Grid className="noprint" item xs={6} sx={{ textAlign: 'left', mt: 3 }}>
                  <Button variant='contained' onClick={() => validarPesquisa()}>Procurar</Button>
                </Grid>

              </Grid>

            </Grid>

            <Grid item xs={12} sx={{ mt: 3 }}>
              <DataTable
                dados={rsRelatorio.registros}
                cabecalho={rsRelatorio.cabecalho}
              />
            </Grid>

          </Grid>

          <Condicional condicao={rsRelatorio.registros.length > 0}>
            <Grid className="noprint" item xs={12} sm={2} alignSelf='center' sx={{ mt: { xs: 0, sm: 2 }, textAlign: 'right' }}>
              <Button variant='contained' onClick={() => handlePrint()}>Imprimir</Button>
              <Button variant='contained' onClick={() => handleDownload()} sx={{ ml: 1 }}>Download</Button>
            </Grid>
          </Condicional>

          <ExibirJSONDev exibir={true} oque={['pesquisa', pesquisa]} />

        </Paper>

      </Container>

    </>
  )

}